import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

import {
  IGetAllChatsParams,
  IGetAllChatsResponse,
  IGetMyChatsParams,
  IGetMyChatsResponse,
} from "../model/types";

class AiChatsService {
  async getAllChats({ page, limit, sort }: IGetAllChatsParams) {
    const params = new URLSearchParams();

    if (page) params.append("page", String(page));

    if (limit) params.append("limit", String(limit));

    if (sort) params.append("sort", sort);

    const response = await $axios.get<
      IGetAllChatsParams,
      AxiosResponse<IGetAllChatsResponse>
    >("/GetAllAIChats", { params });
    return response.data;
  }

  async getMyChats({ page, limit }: IGetMyChatsParams) {
    const params = new URLSearchParams();

    if (page) params.append("page", String(page));

    if (limit) params.append("limit", String(limit));

    const { data } = await $axios.get<
      IGetMyChatsParams,
      AxiosResponse<IGetMyChatsResponse>
    >("/GetMyAIChats", { params });
    return data;
  }
}

export const aiChatsService = new AiChatsService();
